import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const stairwell = defineConnector({
  identifier: "stairwell",
  name: "Stairwell",
  tagLine: "Threat intelligence and file analysis",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://[^/]*\\.stairwell\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Generate an auth token",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to [Stairwell](https://app.stairwell.com), click the **settings** icon, select **Auth tokens** under **Organization**, and click **Generate Token**. Choose **API/CLI token**, name it, and click **Generate**.",
        },
      ],
    },
    {
      title: "Paste your auth token",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://app.stairwell.com/v1/me",
  },
});
